export default __webpack_public_path__ + "static/media/NoTransactionsOrNotAvailable.a97b09b2.svg";